module.exports = __webpack_public_path__ + "e9b13cfe3ac708b810c680a30c2ab089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/activity-coppa-modal.svg
// module id = 1948
// module chunks = 4